import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Typography from "@mui/material/Typography";
import { Controller } from "react-hook-form";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
	slotProps: {
		paper: {
			style: {
				maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
			},
		},
	},
};

const FlexControlledSelectSeparatedLabel = ({
	control,
	name,
	label,
	defaultValue,
	options,
	labelProps,
	margin,
	labelStyles,
	inputStyles,
	...rest
}) => {
	return (
		<Controller
			control={control}
			name={name}
			defaultValue={defaultValue}
			render={({ field: { onChange, value } }) => (
				<Box
					sx={{
						display: "flex",
						gap: "10px",
						alignItems: "center",
						width: "100%",
					}}
				>
					<Box
						sx={{
							flex: "0",
							display: "flex",
							alignItems: "center",
							height: "100%",
							...(rest.multiline && { alignSelf: "start" }),
							...labelStyles,
						}}
					>
						<Typography
							variant="label"
							component="label"
							htmlFor={name}
							sx={{ ...labelProps }}
						>
							{label}:
						</Typography>
					</Box>
					<Box
						sx={{
							flex: "1",
							display: "flex",
							alignItems: "center",
							...inputStyles,
						}}
					>
						<FormControl fullWidth margin={margin ? margin : "none"}>
							{/* <InputLabel size="small" id={name}>
							{label}
						</InputLabel> */}
							<Select
								labelId={name}
								onChange={onChange}
								value={value}
								// label={label}
								size="small"
								MenuProps={MenuProps}
								{...rest}
							>
								{options.map((option) => (
									<MenuItem key={option.value} value={option.value}>
										{option.label}
									</MenuItem>
								))}
							</Select>
						</FormControl>
					</Box>
				</Box>
			)}
		/>
	);
};

export default FlexControlledSelectSeparatedLabel;
